import { render, staticRenderFns } from "./ServiceArea.vue?vue&type=template&id=8bdf8b14&scoped=true&"
import script from "./ServiceArea.vue?vue&type=script&lang=js&"
export * from "./ServiceArea.vue?vue&type=script&lang=js&"
import style0 from "./ServiceArea.vue?vue&type=style&index=0&id=8bdf8b14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bdf8b14",
  null
  
)

export default component.exports